module.exports = __webpack_public_path__ + "static/media/MHRP13N0001.4d8e8a70.svg";